<template lang="pug">
ods-module.loyalty-commerce-table
      div(slot="header")
        span {{ this.$t('loyalty.commerces') }}
      filter-table(
         layout="text"
         @inputSearchFilter="inputSearchFilter")
      .credits-table.ods-mt-6
        ods-table(
          v-loading="loadingTable"
          style='width: 100%'
          size="medium"
          height="50vh"
          :data='tableDataRendered'
          )
          ods-table-column(prop='HOLDING' :label="this.$t('loyalty.holding')")
            template(slot-scope="scope")
              div {{ scope.row.holding }} - {{ scope.row.desholding }}
          ods-table-column(prop='CODCADENA' :label="this.$t('loyalty.commercialchain')")
            template(slot-scope="scope")
              div {{ scope.row.codcadena }} - {{ scope.row.descadena }}
          ods-table-column(prop='CODCOM' :label="this.$t('loyalty.storecode')")
            template(slot-scope="scope")
              div {{ scope.row.codcom }}
          ods-table-column(prop='NOMCOMRED' :label="this.$t('loyalty.commerce')")
            template(slot-scope="scope")
              div {{ scope.row.nomcomred }}
        div.footer
          paginator(
            :isNextPage="indMasDatos"
            :currentPage="currentPage"
            @buttonPrevAction="getPrevPage"
            @buttonNextAction="getNextPage")
//- ods-module.loyalty-commerce-table(v-else)
//-   div(slot="header").loyalty-commerce-table__subtitle
//-     span {{ this.$t('loyalty.noData') }}
</template>

<script>
import FilterTable from '@/components/shared/FilterTable'
import Paginator from '@/components/shared/Paginator'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'ComercioTable',
  components: {
    FilterTable,
    Paginator
  },
  props: {
    activarComercios: {
      required: true
    }
  },
  data () {
    return {
      loadingTable: true,
      tableDataRendered: null,
      tableData: null,
      currentPage: null,
      indMasDatos: null,
      paginationParams: null,
      activePagination: false
    }
  },
  computed: {
    ...mapGetters({
      loadingProgram: 'getProgramState'
    })
  },
  methods: {
    ...mapActions(['getCommerce']),
    inputSearchFilter (text) {
      this.tableDataRendered = this.tableData.filter(obj => Object.values(obj).some(val => val.toString().toLowerCase().indexOf(text.toLowerCase()) > -1))
    },
    async getData (params) {
      this.loadingTable = true
      const response = await this.getCommerce(params)
      if (response.registros) {
        this.tableData = Array.isArray(response.registros) ? response.registros : [response.registros]
        this.tableDataRendered = this.tableData
        this.loadingTable = false
      } else {
        this.tableData = null
        this.tableDataRendered = this.tableData
      }
      this.currentPage = response.pantPagina
      this.indMasDatos = response.indMasDatos
      this.paginationParams = {
        claveInicio: response.claveInicio,
        claveFin: response.claveFin
      }
    },
    getPrevPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        retroceder: true
      }
      this.activePagination = true
      this.getData(params)
    },

    getNextPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        avanzar: true
      }
      this.activePagination = true
      this.getData(params)
    }
  },
  watch: {
    async activarComercios (newVal, oldVal) {
      if (newVal) {
        await this.getData()
      }
    },
    async loadingProgram (data, oldData) {
      if (data && this.activarComercios) {
        await this.getData()
      } else {
        if (data && this.activePagination) {
          await this.getData()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.loyalty-commerce-table{
.notfound {
  margin-top: rem(28)
}

&__subtitle{
  display: flex;
  padding: 32px 0 0 24px;
  font-size: 16px;
  font-weight: 400;
  justify-content: center;
}
.ods-table {
  background: #fff;
  margin: 12px 0;
}
}
</style>
